<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24" v-if="siteSelectShow">
            <a-form-model-item label="專區" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="siteId">
              <a-select allowClear v-model='model.siteId'   @change="siteChange" >
                <a-select-option v-for="(item,index) in siteList" :key='index' :value='item.id' :label='item.text' >
                  {{item.siteName}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!--<a-col :span="24">
            <a-form-model-item label="站点code" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="siteCode">
              <a-input v-model="model.siteCode" placeholder="请输入站点code"  ></a-input>
            </a-form-model-item>
          </a-col>-->
          <!--<a-col :span="24">
            <a-form-model-item label="父id" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="parentId">
              <a-input v-model="model.parentId" placeholder="请输入父id"  ></a-input>
            </a-form-model-item>
          </a-col>-->
          <a-col :span="24">
            <a-form-model-item label="栏目編碼" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colCode">
              <a-input v-model="model.colCode" placeholder="自動生成"  disabled></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="栏目名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colName">
              <a-input v-model="model.colName" placeholder="请输入栏目名称"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="欄目圖片" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colImg">
<!--              <a-input v-model="model.colName" placeholder="请输入栏目名称"  ></a-input>-->
              <j-image-upload class="avatar-uploader" :text="'上傳'" v-model="model.colImg" upload-source="hhemp" :disabled="formDisabled"/>
<!--              <j-upload
                :newWindowOpen="`true`"
                upload-source="hhemp"
                bizPath="null"
                :multiple="false"
                :disabled="formDisabled"
                v-model="model.colName"
              ></j-upload>-->
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number v-model="model.sortNo" placeholder="请输入排序"  style="width: 100%"></a-input-number>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="栏目模板" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colType">
              <j-dict-select-tag  v-model="model.colType" dictCode="empzone_col_colType" allow-clear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="栏目链接" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colUrl">
              <a-input v-model="model.colUrl" placeholder="请输入栏目链接"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <j-dict-select-tag :type="'radio'" v-model="model.status" dictCode="empzone_col_status" allow-clear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="栏目介绍" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="colDesc">
              <a-textarea v-model="model.colDesc" placeholder="请输入栏目介绍"  ></a-textarea>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'EmpzoneColForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        siteSelectShow:false,
        model:{},
        siteList:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          colName: [
            { required: true, message: '请输入欄目名称'},
          ],
          sortNo: [
            { required: true, message: '请输入排序'},
          ],
          colType: [
            { required: true, message: '請選擇欄目類型'},
          ],
          status: [
            { required: true, message: '请選擇狀態'},
          ],
        },
        url: {
          add: "/empzone/col/add",
          edit: "/empzone/col/edit",
          queryById: "/empzone/col/queryById/"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
      this.initSiteList();
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      initSiteList(){
        getAction("/empzone/site/list").then(res=>{
          if(res.success){
              this.siteList = res.result;
          }
        })
      },
      siteChange(id){
        const selected = this.siteList.find(item => item.id === id)
        this.$set(this.model,'siteCode',selected.siteCode)
      },
      add () {
        this.modelDefault.status = 'unpublished'
        this.edit(this.modelDefault);
      },
      addChildren(parentId,siteId,siteCode){
        this.siteSelectShow = false;
        this.modelDefault.parentId = parentId
        this.modelDefault.siteId = siteId
        this.modelDefault.siteCode = siteCode
        this.modelDefault.status = 'unpublished'
        this.model = Object.assign({}, this.modelDefault);
        this.visible = true;
      },
      edit (record) {
        const selected = this.siteList.find(item => item.siteCode === this.$store.getters.application.applicationCode)
        if(selected){
          record.siteId = selected.id
          record.siteCode = selected.siteCode
          this.siteSelectShow = false;
        }else{
          this.siteSelectShow = true;
        }
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
